import JSZip from 'jszip';
import FileSaver from "file-saver";
import apiService from '../../services/api.service';
import firebaseService from '../../services/firebase.service';
import SHA256 from "crypto-js/sha256";
import {nanoid} from "nanoid";

// action types
export const PIC_SCAN = 'picScan';
export const PIC_UPLOAD = 'picUpload';
export const PIC_DELETE = 'picDelete';
export const PIC_DOWNLOAD = 'picDownload';
export const FETCH_ANALYSIS = 'fetchAnalysis';


// mutation types
const SET_ANALYSIS = 'setAnalysis';
const SET_TEMP_PIC_FILE = 'setTempPicFile';
const SET_REPORT_FIELDS = 'saveReportFields';


const state = {
   analysis: [],
   tempPicFile: null,
};

const getters = {
   analysis: (state) => {
      return state.analysis;
   }
};

const mutations = {
   [SET_ANALYSIS](state, analysis) {
      state.analysis = analysis;
   },
   [SET_TEMP_PIC_FILE](state, file) {
      state.tempPicFile = file;
   },
   [SET_REPORT_FIELDS](state, fields) {
      state.reportFields = fields;
   },
};

const actions = {
   [PIC_UPLOAD](context, folder) {
      return new Promise((resolve, reject) => {
         let formdata = new FormData;
         formdata.append('file', context.getters.tempPicFile);
         formdata.append('folder', folder);
         apiService.setPdfApiAsBaseUrl();
         apiService.post('/pic/upload', formdata).then((res) => {
            context.commit(SET_TEMP_PIC_FILE, null);
            console.log(res.data);
            context.getters.reportFields.source_id = res.data.id;
            context.getters.reportFields.source = res.data.url;
            context.getters.reportFields.uid = context.getters.user.uid;
            context.getters.reportFields.user = context.getters.user.name;
            context.getters.reportFields.email = context.getters.user.email;
            context.getters.reportFields.captured_file = res.data.url;
            context.getters.reportFields.captured_file_id = res.data.id;
            context.getters.reportFields.captured_file_hash = SHA256(`${res.data.url}_${nanoid()}`).toString().substr(0, 25);
            context.commit(SET_REPORT_FIELDS, context.getters.reportFields);
            resolve(res.data);
         }).catch((err) => {
            context.commit(SET_TEMP_PIC_FILE, null);
            reject(`[picUpload] => ${err}`)
         });
      });
   },
   [PIC_DOWNLOAD](context, id) {
      return new Promise((resolve, reject) => {
         let files = [
            {name: 'timeproof.pdf', url: `/timeproof/${id}`},
            {name: 'certtificate.pdf', url: `/certificate/${id}`}
         ];

         let zip = new JSZip();
         const promises = [];
         files.forEach((item) => {
            const promise = apiService.setPdfDownloadAsBaseUrlNew(item.url).then((arraybuffer) => {
               zip.file(item.name, arraybuffer);
            }).catch((err) => {
               reject(`[picDownload] => ${err}`)
            });
            promises.push(promise);
         });

         Promise.all(promises).then(() => {
            zip.generateAsync({type: "blob"}).then(content => {
               FileSaver.saveAs(content, "file.zip");
               resolve(true);
            });
         });
      });
   },
   [PIC_DELETE](context, {id, source_id, captured_file_id}) {
      return new Promise((resolve, reject) => {
         firebaseService.deleteReport(id).then(() => {
            let files = [
               {id: source_id},
               {id: captured_file_id}
            ];

            const promises = [];
            files.forEach((item) => {
               apiService.setPdfApiAsBaseUrl();
               const promise = apiService.post('/pic/delete', {"pub_id": item.id}).then(() => {
                  promises.push(promise);
               }).catch((err) => {
                  reject(`[picDelete] => ${err}`)
               });
            });

            Promise.all(promises).then(() => {
               const reports = context.getters.reports;
               context.commit(SET_ANALYSIS, reports.filter((el) => el.id !== id));
               resolve(true);
            });
         }).catch((err) => {
            reject(`[picDelete] => ${err}`)
         });
      });
   },
   [FETCH_ANALYSIS](context, id) {
      firebaseService.fetchAnalysis(id).then((res) => {
         console.log(res);
         context.commit(SET_ANALYSIS, res);
      }).catch((err) => {
         console.error(`[fetchAnalysis] => ${err}`);
      })
   },
};

export default {
   state,
   actions,
   getters,
   mutations
}

